import dayjs from 'dayjs';
import type { ScheduledAction } from '@demind-inc/core';

/** Hours strictly before this are treated as after midnight and rolled to the next calendar day. */
export const SLEEP_AFTER_MIDNIGHT_HOUR = 16;

export type AllPlanDatedSchedule = ScheduledAction & {
  /** YYYY-MM-DD of the Plan My Day run (selected date) that produced this suggestion. */
  planDate?: string;
};

export const stampAllPlanSchedulesWithTargetDate = (
  schedules: ScheduledAction[],
  targetDate: string
): AllPlanDatedSchedule[] =>
  schedules.map((schedule) => ({ ...schedule, planDate: targetDate }));

/**
 * Date key that owns this suggestion in Plan My Day UI/cache.
 * Prefer the stamped selected date so post-midnight sleep (stored on the next
 * calendar day) still belongs to the day that was planned.
 */
export const getAllPlanScheduleOwnershipDateKey = (
  schedule: AllPlanDatedSchedule
): string | null => {
  if (schedule.planDate) {
    return schedule.planDate;
  }

  if (!schedule.startDate) {
    return null;
  }

  const start = dayjs(schedule.startDate);
  if (!start.isValid()) {
    return null;
  }

  if (schedule.eventFrom === 'sleep' && start.hour() < SLEEP_AFTER_MIDNIGHT_HOUR) {
    return start.subtract(1, 'day').format('YYYY-MM-DD');
  }

  return start.format('YYYY-MM-DD');
};

export const scheduleFallsOnDate = (schedule: AllPlanDatedSchedule, dateKey: string): boolean =>
  getAllPlanScheduleOwnershipDateKey(schedule) === dateKey;
